<app-primary-button [isLoading]="isLoading" [disabled]="disabled">
  <ng-content></ng-content>
  <i class="material-icons ml-2 mb-1">arrow_forward</i>
</app-primary-button>